/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'

import { Input, Col, Row, FormGroup, FormFeedback, Label, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'

import Select from 'react-select'

import {AppContext} from '../AppContext';

class AddKeywordToGroupModal extends React.Component 
{
  cancelModal(refresh)
  {
    this.setState(
    {
      valueTypeIsValid: undefined, 
      newKeywordIsValid: undefined,
      selectedKeyword: null,
      valueType: null,
      newKeyword: '',
      createButtonDisabled: true
    });
    this.props.closeModal(refresh);
  }

  constructor(props) 
  {
    super();

    this.state =
    {
      selectedKeyword: null,
      valueType: null,
      valueTypeIsValid: undefined,
      valueTypeFB: null,
      newKeywordIsValid: undefined,
      newKeyword: '',
      createButtonDisabled: true,
      newKeyordFB: null
    }

    this.createButtonHandler = this.createButtonHandler.bind(this);
    this.keywordValueTypeChanged = this.keywordValueTypeChanged.bind(this);
    this.setNewKeyword = this.setNewKeyword.bind(this);
    this.cancelModal = this.cancelModal.bind(this);
  }

  async createButtonHandler()
  {
    let keyword = this.state.newKeyword.trim();

    this.setState({createButtonDisabled: true});

    let bodyData = {};
    bodyData.keyword = keyword;
    bodyData.keywordGroupId = this.props.keywordGroup.keywordGroupId;
    bodyData.keywordValueType = this.state.valueType.value;

    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'createKeyword', bodyData);
    if ('success' !== result.status)
    {
      this.setState({createButtonDisabled: false});
      return this.context.dbTwig.apiErrorHandler(result, 'Unable to create a keyword');
    } 

    this.context.postNotification('info', 'Changes saved.');
    this.cancelModal(true);
  }

  keywordValueTypeChanged(selectedValueType)
  {
    let buttonDisabled = true;
    if (this.state.newKeywordIsValid && null !== selectedValueType) buttonDisabled = false;

    this.setState(
    {
      valueType: selectedValueType,
      valueTypeIsValid: (null === selectedValueType ? false : true),
      createButtonDisabled: buttonDisabled
    });
  }

  render() 
  {
    let newKeywordIsValid = (undefined === this.state.newKeywordIsValid ? true : this.state.newKeywordIsValid);
    let keywordValueTypeFB = null;
    let valueTypeIsValid = (undefined === this.state.valueTypeIsValid ? true : this.state.valueTypeIsValid);
    if (!valueTypeIsValid)
      keywordValueTypeFB = (
        <div style={{color: 'red'}}>
          <Row><Col>{this.state.valueTypeFB}</Col></Row>
        </div>
      );

    return (
      <div>
        <Modal isOpen={this.props.modalIsOpen} toggle={this.cancelModal.bind(this, false)} autoFocus={false} >
          <ModalHeader toggle={this.cancelModal.bind(this, false)}>Add New Keyword To Group</ModalHeader>
          <ModalBody>
            <Row><Col>Create a new keyword</Col></Row>
            <FormGroup id="newKeywordFormGroup" row style={{paddingTop: "10px"}}>
              <Label for="newKeyword" sm="4">New Keyword...</Label>
              <Col sm="8">
                <Input type="text" id="newKeyword" placeholder="Enter keyword..." 
                  invalid={!newKeywordIsValid} valid={newKeywordIsValid} autoFocus
                  value={this.state.newKeyword} onChange={this.setNewKeyword}
                />
                <FormFeedback valid={false}>{this.state.newKeywordFB}</FormFeedback>
              </Col>
            </FormGroup>
            <FormGroup id="keywordValueTypeFormGroup" row>
              <Label for="keywordValueType" sm="4">Choose type it accepts</Label>
              <Col sm="8">
                <Select id='keywordValueType' value={this.state.valueType} options={this.props.keywordValueTypes} 
                  getOptionLabel={option => option.label} getOptionValue={option => option.value}
                  clearable={false} onChange={this.keywordValueTypeChanged} />
                {keywordValueTypeFB}
              </Col>
            </FormGroup>
            <FormGroup row>
              <Col sm={{ size: 9, offset: 3 }}>
                <Button id="createKeywordButton" disabled={this.state.createButtonDisabled} onClick={this.createButtonHandler} 
                  color="primary">Create Keyword</Button>
              </Col>
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.cancelModal.bind(this, false)}>Cancel</Button>
          </ModalFooter>
        </Modal>        
      </div>
    );
  }

  setNewKeyword(event)
  {
    let buttonDisabled = true;
    let valid = ("" === event.target.value ? false : true);
    if (valid && this.state.valueTypeIsValid) buttonDisabled = false;
    this.setState({newKeyword: event.target.value, newKeywordIsValid: valid, createButtonDisabled: buttonDisabled});
  }
}

AddKeywordToGroupModal.contextType = AppContext;

export default AddKeywordToGroupModal